import { render, staticRenderFns } from "./apartment-location.vue?vue&type=template&id=72c6d2d8&"
import script from "./apartment-location.ts?vue&type=script&lang=ts&"
export * from "./apartment-location.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports